/* master.data */
import { cfg } from '../../../config';
import { http } from '../http';
import { type ApiRsp } from '../types';

interface MasterService {
    getEmpType(): Promise<ApiRsp>;
    getEmpLevel(): Promise<ApiRsp>;
    getPosition(): Promise<ApiRsp>;
    // dropdown
    setEmpTypeDropdown(elm: HTMLSelectElement): Promise<void>;
    setEmpLevelDropdown(elm: HTMLSelectElement): Promise<void>;
    setPositionDropdown(elm: HTMLSelectElement): Promise<void>;
}

export const master: MasterService = {
    getEmpType: () => {
        const url = cfg.hub.API + `/emp-types`;
        return http.get(url);
    },
    getEmpLevel: () => {
        const url = cfg.hub.API + `/emp-levels`;
        return http.get(url);
    },
    getPosition: () => {
        const url = cfg.hub.API + `/positions`;
        return http.get(url);
    },
    // dropdown
    setEmpTypeDropdown: async (elm: HTMLSelectElement) => {
        const resp = await master.getEmpType();
        setDropdown(elm, resp.data as EmpMasterData[]);
    },
    setEmpLevelDropdown: async (elm: HTMLSelectElement) => {
        const resp = await master.getEmpLevel();
        setDropdown(elm, resp.data as EmpMasterData[]);
    },
    setPositionDropdown: async (elm: HTMLSelectElement) => {
        const resp = await master.getPosition();
        setDropdown(elm, resp.data as EmpMasterData[]);
    },
};

const setDropdown = (elm: HTMLSelectElement, data: EmpMasterData[]) => {
    data.forEach(val => {
        const option = document.createElement('option');
        option.value = val.id.toString();
        option.textContent = val.name;
        elm.appendChild(option);
    });
};

type EmpMasterData = {
    id: number;
    code: string;
    name: string;
    is_active: boolean;
};
export type EmpType = EmpMasterData;
export type EmpLevel = EmpMasterData;
export type Position = EmpMasterData;